import { useSearchParams } from 'react-router-dom';
import FormActionButtonLayout from '../../../components/layout/Form/FormActionButtonLayout';
import { Dispatch, SetStateAction } from 'react';
import { isSubmitEnabled } from '../../../lib/helperFuncs';
import { Button, Box } from '@mui/material';
import { VerticalStep, VerticalStepper } from '../../../components/Stepper';
import { Formik } from 'formik';
import { initialValuesEditDocument } from '../Registrations/types';
import { editDocumentionValidation } from '../Registrations/validationSchema';
import { renderErrors } from '../../../components/form_v2/helpers';
import LinesSkeleton from '../../../components/Skeletons/LinesSkeleton';
import Details from '../../../components/Details/Details';
import { House } from '@mui/icons-material';

interface IPreviewDocument {
  setRenderPreview: Dispatch<SetStateAction<boolean>>;
  onSubmit: (values: any) => Promise<void>;
  data: any;
  isLoading?: boolean;
  erga: any[]
}


const PreviewTekmrio = ({
  data,
  onSubmit,
  setRenderPreview,
  isLoading,
  erga
}: IPreviewDocument) => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const basic_info_details = [
    {
      name: 'Μοναδικός Κωδικός Τεκμηρίου',
      value: data.documentsUniqueCode || '-',
      refValue: 'documentsUniqueCode'
    },
    {
      name: 'Aναγνωριστικό Τεκμηρίου',
      value: data.documentIdentifier || '-',
      refValue: 'documentIdentifier'
    },
    {
      name: 'Φορέας που ανήκει το Τεκμήριο',
      value: data.documentsRelationOrganisation || '-',
      refValue: 'documentsRelationOrganisation'
    },
    {
      name: 'Συλλογή που ανήκει το Τεκμήριο',
      value: data.documentsRelationCollection || '-',
      refValue: 'documentsRelationCollection'
    },
    {
      name: 'Τίτλος Τεκμηρίου',
      value: data.documentsTitle || '-',
      refValue: 'documentsTitle'
    },
    {
      name: 'Τίτλος Τεκμηρίου στα Αγγλικά',
      value: data.documentsEnTitle || '-',
      refValue: 'documentsEnTitle'
    },
    {
      name: 'Τύπος Τεκμηρίου',
      value: data.documentsType || '-',
      refValue: 'documentsType'
    },
    {
      name: 'Περιγραφή Τεκμηρίου στα Αγγλικά',
      value: data.documentsEnDescription || '-',
      refValue: 'documentsEnDescription'
    },
    {
      name: 'Ημερομηνία Δημιουργίας',
      value: data.documentsDateCreation || '-',
      refValue: 'documentsDateCreation'
    },
    {
      name: 'Μορφότυπο',
      value: data.documentsFormat || '-',
      refValue: 'documentsFormat'
    },
    {
      name: 'Διάρκεια',
      value: data.documentsDuration || '-',
      refValue: 'documentsDuration'
    },
    {
      name: 'Χρώμα',
      value: data.documentsColor || '-',
      refValue: 'documentsColor'
    },
    {
      name: 'Ηχος',
      value: data.documentsSound || '-',
      refValue: 'documentsSound'
    },
    {
      name: 'Τεχνική',
      value: data.documentsTechnical || '-',
      refValue: 'documentsTechnical'
    },
    {
      name: 'Μέγεθος',
      value: data.documentsSize || '-',
      refValue: 'documentsSize'
    },
    {
      name: 'Ύψος',
      value: data.documentsHeight || '-',
      refValue: 'documentsHeight'
    },
    {
      name: 'Πλάτος',
      value: data.documentsWidth || '-',
      refValue: 'documentsWidth'
    },
    {
      name: 'Frame Rate',
      value: data.documentsFrameRate || '-',
      refValue: 'documentsFrameRate'
    },
    {
      name: 'Aspect Ratio',
      value: data.documentsAspectRatio || '-',
      refValue: 'documentsAspectRatio'
    },
    {
      name: 'Copyright',
      value: data.documentsCopyright || '-',
      refValue: 'documentsCopyright'
    },
    {
      name: 'Άδεια Χρήσης',
      value: data.documentsLicence || '-',
      refValue: 'documentsLicence'
    },
    {
      name: 'Παρατηρήσεις Σχόλια Τεκμηρίου',
      value: data.documentsComments || '-',
      refValue: 'documentsComments'
    },
    {
      name: 'Παρατηρήσεις Σχόλια Τεκμηρίου English',
      value: data.documentsEnComments || '-',
      refValue: 'documentsEnComments'
    },
    {
      name: 'Youtube Τίτλος',
      value: data.documentsVimeoYtTitle || '-',
      refValue: 'documentsVimeoYtTitle'
    },
    {
      name: 'Youtbe URL',
      value: data.documentsVimeoYtUrl || '-',
      refValue: 'documentsVimeoYtUrl'
    },
    {
      name: 'Φωτογραφίες',
      value: data?.documentsAttachedMediaImages?.length > 0
        ? data?.documentsAttachedMediaImages?.map((image: any) => image?.name || image)
        : '-',
      refValue: 'documentsAttachedMediaImages'
    },
    {
      name: 'Έγγραφα',
      value: data.documentsAttachedMediaFiles?.length > 0
        ? data?.documentsAttachedMediaFiles?.map((file: any) => file?.name || file)
        : '-',
      refValue: 'documentsAttachedMediaFiles'
    },
    {
      name: 'Έργα',
      value: erga.find(ergo => ergo.value == data.documentsRelationProject).key ,
      refValue: 'documentsRelationProject'
    },
  ];

  const basicInfo = <Box
    display='flex'
    justifyContent='flex-start'
  >
    <Box width='fit-content'>
      {isLoading
        ? <LinesSkeleton lines={basic_info_details.length} />
        : <Details
          removeLines
          rows={basic_info_details}
        />
      }
    </Box>
  </Box>;

  const steps = [
    {
      label: 'Βασικές Πληροφορίες Τεκμηρίου',
      content: basicInfo,
      icon: <House />
    }
  ];

  return (
    <>
      <VerticalStepper activeStep={0}>
        {steps.map(step => {
          return (
            <VerticalStep
              active={true}
              key={step.label}
              label={step.label}
              icon={step.icon}>
              {step.content}
            </VerticalStep>
          );
        })}
      </VerticalStepper>
      <Formik
        enableReinitialize
        onSubmit={() => undefined}
        initialValues={initialValuesEditDocument(data)}
        validationSchema={editDocumentionValidation}
        validateOnMount={true}
      >
        {formik =>
          (<>
            <Box ml={2} mt={3}>
              {renderErrors(
                formik.errors,
                [
                  ...basic_info_details
                ]
              )}
            </Box>
            <FormActionButtonLayout>
              <Button 
                variant='outlined' 
                color='error'
                onClick={() => {
                  setRenderPreview(false);
                  searchParams.delete('preview');
                  searchParams.set('edit', 'true');
                  setSearchParams(searchParams);
                }}
              > 
                Επιστροφή               
              </Button>
              <Button
                disabled={isSubmitEnabled(formik.errors, true)}
                variant='contained'
                onClick={() => onSubmit(data)}
              > 
                Υποβολή
              </Button>
            </FormActionButtonLayout>
          </>)}
      </Formik>
    </>
  );
};

export default PreviewTekmrio;